import { Navigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { viewProfile } from "../store/auth/authSlice";
import LoadingAnimation from "../components/common/LoadingAnimation";

export const PrivateRoutes = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user, isLoading } = useSelector((state) => state.auth);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    if (user) {
      setIsAuthenticated(true);
      setIsCheckingAuth(false);
      return;
    }

    const checkAuthentication = async () => {
      try {
        await dispatch(viewProfile()).unwrap();
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      } finally {
        setIsCheckingAuth(false);
      }
    };

    checkAuthentication();
  }, [dispatch, user]);

  if (isCheckingAuth || isLoading) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white dark:bg-gray-900 transition-opacity duration-500">
        <div className="text-center">
          <LoadingAnimation size="lg" className="mx-auto mb-6" />
          <div className="text-xl font-medium mt-4 bg-clip-text text-transparent bg-gradient-to-r from-teal-500 to-pink-500 animate-pulse-slow">
            OnPrintZ
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const isLogoutAction =
      location.pathname === "/logout" ||
      location.search.includes("logout=true");

    if (!isLogoutAction) {
      sessionStorage.setItem(
        "redirectAfterLogin",
        JSON.stringify({
          pathname: location.pathname,
          search: location.search,
          hash: location.hash,
        }),
      );
    } else {
      sessionStorage.removeItem("redirectAfterLogin");
    }

    return <Navigate to="/login" replace={true} />;
  }

  return children;
};
